import React from 'react';
import { TabContainer } from 'assets/containers/AssetDetailView/styles';

const PreservedTabView = ({ tabs, activeTab }) => {
  const items = tabs.map((tab, i) => ({
    key: tab.key ?? tab.title,
    label: tab.title,
    children: tab.content,
    className: 'overview-pane',
  }));

  return (
    <TabContainer items={items} activeKey={activeTab || tabs?.[0].key} style={{ overflow: 'visible' }} />
  );
};

export default PreservedTabView;
